import {
  AppBar,
  Container,
  IconButton,
  Toolbar,
  CircularProgress,
  Grid,
} from "@material-ui/core";

import { Menu, Warning } from "@mui/icons-material";
import Logos from "assets/img/logos/group.png";

import NotificationsDropdown from "./notification";
import HelperDropdown from "./help";
import UserDropdown from "./user";

import { IsMobile, IsSmall } from "utils/is-mobile";
import { getColorByEnv } from "utils/get-colors-by-env";

export default function AdminNavbar({
  userNotifications,
  userAllNotifications,
  setOpenDialog,
  toggleSidebar,
}) {
  const isMobile = IsMobile();
  const isSmall = IsSmall();

  return (
    <AppBar position="static" style={{ backgroundColor: getColorByEnv() }}>
      <Toolbar disableGutters>
        <Container maxWidth={false}>
          <Grid
            container
            alignItems="center"
            style={{ margin: "1rem 0", justifyContent: "space-between" }}
          >
            <Grid item xs={7} hidden={isMobile}>
              <img
                src={Logos}
                alt="logo"
                style={{
                  height: isSmall ? "5vh" : "8vh",
                }}
              />
            </Grid>

            <Grid item xs={isMobile ? 12 : 5}>
              <Grid
                container
                alignItems="center"
                style={{
                  justifyContent: isMobile ? "space-between" : "flex-end",
                }}
              >
                <IconButton
                  hidden={!isSmall}
                  onClick={() => toggleSidebar()}
                  color="inherit"
                >
                  <Menu />
                </IconButton>
                <Grid container style={{ width: "auto" }}>
                  <IconButton
                    onClick={() => setOpenDialog(true)}
                    color="inherit"
                  >
                    <Warning />
                  </IconButton>

                  {userNotifications ? (
                    <NotificationsDropdown
                      userNotifications={userNotifications}
                      userAllNotifications={userAllNotifications}
                    />
                  ) : (
                    <CircularProgress
                      color="inherit"
                      style={{
                        width: 22,
                        height: 22,
                        margin: "0.6rem",
                      }}
                    />
                  )}

                  <HelperDropdown />

                  <UserDropdown />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Toolbar>
    </AppBar>
  );
}
